import { OrderSourceEnum, OrderStatusEmrEnum } from "./PatientModels";

export const OrderSource: Record<OrderSourceEnum, { [key: string]: string }> = {
   [OrderSourceEnum.NaviScript]: { label: 'NaviScript', color: '#0067B1' },
   [OrderSourceEnum.EMR]: { label: 'EMR', color: '#0067B1' },
   [OrderSourceEnum.ScriptSure]: { label: 'ScriptSure', color: '#0067B1' },
   [OrderSourceEnum.EmrModified]: { label: 'EMR/modified', color: '#0067B1' },

};

export const EmrSyncStatus: Record<OrderStatusEmrEnum, string> = {
   [OrderStatusEmrEnum.NotStarted]: 'The Med Sheet sync is in progress',
   [OrderStatusEmrEnum.Success]: 'The Med Sheet sync is successful',
   [OrderStatusEmrEnum.Error]: 'The Med Sheet failed to sync.',
   [OrderStatusEmrEnum.Processing]: 'The Med Sheet sync is in progress',
   [OrderStatusEmrEnum.UiError]: 'The Med Sheet failed to sync.',
   [OrderStatusEmrEnum.MedOrderNotFoundError]: 'The Med Sheet failed to sync.',
   [OrderStatusEmrEnum.TeamNotFoundError]: 'The Med Sheet failed to sync.',
   [OrderStatusEmrEnum.MedOrderMissesDataError]: 'The Med Sheet failed to sync.',
   [OrderStatusEmrEnum.PatientNotFoundError]: 'The Med Sheet failed to sync.',
   [OrderStatusEmrEnum.SaveError]: 'The Med Sheet failed to sync.',
   [OrderStatusEmrEnum.PendingImport]: 'The Med Sheet sync is in progress',
   [OrderStatusEmrEnum.DuplicateError]: 'The Med Sheet exists in the EMR.',
   [OrderStatusEmrEnum.PotentialDuplicateError]: 'Possible duplicate Med Sheet found in the EMR.',
   [OrderStatusEmrEnum.NA]: '',
   [OrderStatusEmrEnum.PartialPullSuccess]: '',
};

export const MedPullSyncStatus: Record<OrderStatusEmrEnum, string> = {
   [OrderStatusEmrEnum.NotStarted]: 'N/A',
   [OrderStatusEmrEnum.Success]: 'Successful',
   [OrderStatusEmrEnum.Error]: 'Error',
   [OrderStatusEmrEnum.Processing]: 'N/A',
   [OrderStatusEmrEnum.UiError]: 'Error',
   [OrderStatusEmrEnum.MedOrderNotFoundError]: 'Error',
   [OrderStatusEmrEnum.TeamNotFoundError]: 'Error',
   [OrderStatusEmrEnum.MedOrderMissesDataError]: 'Error',
   [OrderStatusEmrEnum.PatientNotFoundError]: 'Patient Not Found',
   [OrderStatusEmrEnum.SaveError]: 'N/A',
   [OrderStatusEmrEnum.PendingImport]: 'N/A',
   [OrderStatusEmrEnum.DuplicateError]: 'N/A',
   [OrderStatusEmrEnum.PotentialDuplicateError]: 'N/A',
   [OrderStatusEmrEnum.NA]: 'N/A',
   [OrderStatusEmrEnum.PartialPullSuccess]: 'Partially Successful',
};

export enum MedicationStatusEnum {
   Invalid = 0,
   PendingSaved = 1,
   PendingMdApproval = 2,
   Ordered = 3,
   Denied = 4,
   Cancelled = 5,
   Discontinued = 6,
   PharmacyError = 7,
}

export const MedicationStatusLabels: Record<
   MedicationStatusEnum,
   { [key: string]: string }
> = {
   [MedicationStatusEnum.Invalid]: { label: 'Unknown', color: '#58595B' },
   [MedicationStatusEnum.PendingSaved]: {
      label: 'Pending (Save Only)',
      color: '#0067B1',
   },
   [MedicationStatusEnum.PendingMdApproval]: {
      label: 'Pending (Sent to Physician)',
      color: '#0067B1',
   },
   [MedicationStatusEnum.Ordered]: { label: 'Ordered', color: '#3E8D57' },
   [MedicationStatusEnum.Denied]: {
      label: 'Prescriber Denied',
      color: '#EB5757',
   },
   [MedicationStatusEnum.Cancelled]: { label: 'Cancelled', color: '#EB5757' },
   [MedicationStatusEnum.Discontinued]: {
      label: 'Discontinued Medications',
      color: '#58595B',
   },
   [MedicationStatusEnum.PharmacyError]: {
      label: ' Error',
      color: '#EB5757',
   },
};
